export default __webpack_public_path__ + "static/Entenda0059-329d4144696f52e5a379d338a3677fc2.jpg";